var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/00faa6b002e37190be5d3e852815dcf8.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2946e89c658eb28b8012f158ba22df09.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2feb6165c7b2ba1180dfb72ba268b3bc.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/665406366cdea63e19f15fdaea5b7fb2.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8fb47f6fb5b88c3576a952e3aa76ead0.js').default;
var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95c0158d26d17d55b58613a97325c31e.js').default;
var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9aa981e692146c9d12772005a854f1a3.js').default;
var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a879ba925594ec37f9d598d69c5c7ad3.js').default;
var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b2d1b7cc0fd93ae8f8fddccdad4fb73a.js').default;
var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c08852666bd1ea08ebb09d557ce1d764.js').default;
var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_11 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2552eeb0711bc612424e36c6026e2c4.js').default;
var scope_12 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f980dd220ed3f0aa240d6752025b1835.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12 )
    